import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const store = new Vuex.Store({
    state () {
        return {
            count:10,
            user_title: '',
            user_logo: '',
            user_logo_height: '',
            user_top_bc: '',
            web_title: '',
            web_logo: '',
            web_logo_height: '',
            web_top_bc: ''
        }
    },
    mutations: {
        add(state){
            state.count += 6
        },
        setUserConfig (state, [title, logo, logoHeight, topBC]) {
            state.user_title = title
            state.user_logo = logo
            state.user_logo_height = logoHeight
            state.user_top_bc = topBC
        },
        setWebTitle (state, title) { state.web_title = title },
        setWebConfig (state, [title, logo, logoHeight, topBC]) {
            state.web_title = title
            state.web_logo = logo
            state.web_logo_height = logoHeight
            state.web_top_bc = topBC
        }
    }
})

export default store


// WEBPACK FOOTER //
// ./src/store/index.js